// let env = 'development';
let CLASSAPI = "" // 在线课堂域名
let IMGAPI = "" // 图片域名
let JAVAORDER = "" // 订单接口域名
let JAVAAPI = "" // JAVA接口域名
let PHPAPI = "" // PHP接口域名
let PHPMAPI = "" // 移动商城首页
let YZAPI = "" // pc验证域名
let ZJKAPI = "" // 专家库域名
let ULKAPI = "" // 优料库
let MULKAPI = "" // 优料库移动版
let PAYAPI = "" // 支付
let HZAPI = "" // 慧正域名
let HZMAPI = "" // 慧正移动端域名
let ZHAPI = "" // 展会域名
const ACTIVITYAPI = "https://zt.ibuychem.com/" // 活动域名
let ENV = "development" // 环境

const isLocalDev = process.env.REACT_APP_PROJECT_ENV === "dev"

if (
  !process.env.REACT_APP_PROJECT_ENV &&
  process.env.NODE_ENV === "production"
) {
  PAYAPI = "//payapi.ibuychem.com/"
  CLASSAPI = "//m.ibuychem.com/"
  IMGAPI = "//img.ibuychem.com/"
  JAVAORDER = "//order.ibuychem.com/"
  JAVAAPI = "//www.ibuychem.com/"
  PHPAPI = "//cn.ibuychem.com/"
  PHPMAPI = "//cn.ibuychem.com/m/"
  YZAPI = "//user.ibuychem.com/"
  ZJKAPI = "//m.ibuychem.com/"
  ULKAPI = "https://ibuychem.ylcool.com/"
  MULKAPI = "https://m.ylcool.com/"
  HZAPI = "//www.hzeyun.com/"
  HZMAPI = "//m.hzeyun.com/"
  ZHAPI = "//ex.hzeyun.com/"
  ENV = "production"
} else {
  PAYAPI = "https://payapi-stg.ibuychem.com/"
  CLASSAPI = "https://m-stg.ibuychem.com/"
  IMGAPI = "https://imgdev.ibuychem.com/"
  JAVAORDER = "https://order-stg.ibuychem.com/"
  JAVAAPI = "https://www-stg.ibuychem.com/"
  PHPAPI = "https://cn-stg.ibuychem.com/"
  PHPMAPI = "//cn-stg.ibuychem.com/m/"
  YZAPI = "https://user-stg.ibuychem.com/"
  ZJKAPI = "https://m-stg.ibuychem.com/"
  ULKAPI = "https://ibuychem-stg.ylcool.com/"
  MULKAPI = "https://m-stg.ylcool.com/"
  HZAPI = "https://www-stg.hzeyun.com/"
  HZMAPI = "https://m-stg.hzeyun.com/"
  ZHAPI = "https://ex-stg.hzeyun.com/"
}

export default {
  PAYAPI,
  CLASSAPI,
  IMGAPI,
  JAVAAPI,
  JAVAORDER,
  PHPAPI,
  PHPMAPI,
  ULKAPI,
  MULKAPI,
  YZAPI,
  ZJKAPI,
  HZAPI,
  HZMAPI,
  ZHAPI,
  ACTIVITYAPI,
  ENV,
  isLocalDev,
}



// WEBPACK FOOTER //
// ./src/utils/config.ts